if (!Array.prototype.unique) {
  Array.prototype.unique = function () {
    return this.filter((v, i, a) => a.indexOf(v) === i);
  };
}

if (!Array.isArray) {
  Array.isArray = function (arg) {
    return Object.prototype.toString.call(arg) === "[object Array]";
  };
}



// WEBPACK FOOTER //
// ./polyfills.js